/**
 * @param {number} base
 * @param {number} percentage
 * @returns {number}
 */
export const addPercentage = (base, percentage) => {
	return base * (1 + percentage);
};



// WEBPACK FOOTER //
// ./src/helpers/addPercentage.js